var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Mobile Scheme",
      prop: "forMobile"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.forMobile,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "forMobile", $$v);
      },
      expression: "formData.forMobile"
    }
  }), _c("span", {
    staticClass: "text-small text-italic"
  }, [_vm._v(" (additional scheme, applies only to orders placed from Android / iOS, no dealer mapping needed) ")])], 1), _vm.formData.forMobile ? [_c("el-form-item", {
    attrs: {
      label: "Target Branches",
      prop: "targetBranchIds"
    }
  }, [_c("el-select", {
    attrs: {
      multiple: "",
      filterable: "",
      clearable: "",
      "collapse-tags": "",
      placeholder: "All branches"
    },
    model: {
      value: _vm.targetBranchIds,
      callback: function ($$v) {
        _vm.targetBranchIds = $$v;
      },
      expression: "targetBranchIds"
    }
  }, _vm._l(_vm.branchList, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: _vm.branchLabel(branch),
        value: branch.id
      }
    });
  }), 1), _c("span", {
    staticClass: "text-small text-italic"
  }, [_vm._v(" (only dealers of these branches get this scheme; leave empty for all) ")])], 1), _c("el-form-item", {
    attrs: {
      label: "Target States",
      prop: "targetStateIds"
    }
  }, [_c("el-select", {
    attrs: {
      multiple: "",
      filterable: "",
      clearable: "",
      "collapse-tags": "",
      placeholder: "All states"
    },
    model: {
      value: _vm.targetStateIds,
      callback: function ($$v) {
        _vm.targetStateIds = $$v;
      },
      expression: "targetStateIds"
    }
  }, _vm._l(_vm.stateList, function (state) {
    return _c("el-option", {
      key: state.id,
      attrs: {
        label: state.name,
        value: state.id
      }
    });
  }), 1), _c("span", {
    staticClass: "text-small text-italic"
  }, [_vm._v(" (only dealers whose primary address is in these states; leave empty for all) ")])], 1)] : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      name: "name",
      required: "",
      placeholder: "Name"
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Validity",
      prop: "validity"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "daterange",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      format: "dd-MM-yyyy",
      "default-time": ["00:00:00", "23:59:59"]
    },
    model: {
      value: _vm.validity,
      callback: function ($$v) {
        _vm.validity = $$v;
      },
      expression: "validity"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Image",
      prop: "image"
    }
  }, [_c("file-upload", {
    attrs: {
      url: "/schemes/upload",
      field: "image",
      accept: ".jpg, .jpeg, .png",
      "max-size": "1",
      "file-list": _vm.image
    },
    on: {
      change: _vm.imageUploaded
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 2)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };